function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 152.725 -41.706)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-445.887 238.289c4.255-2.516 6.052-5.882 6.052-9.586 0-1.084.154-52.175.154-52.175h-50.652s-.238 51.53-.238 52.175c0 3.731 2.643 7.12 6.957 9.643-3.051.444-6.068.987-9.052 1.642a84.383 84.383 0 0113.448 10.672c5.908 5.747 10.796 12.11 14.634 18.973 3.837-6.862 8.728-13.226 14.63-18.973a84.904 84.904 0 0113.46-10.678c-3.051-.66-6.197-1.196-9.344-1.667z",
  stroke: "#000",
  strokeWidth: 0.975
}), /*#__PURE__*/React.createElement("path", {
  d: "M-399.294 354.411c-3.133-6.283-3.22-14.498-1.828-20.047 1.426-5.708 14.948-16.51 14.948-16.51 23.82-23.17 29.273-56.196 12.184-73.764-17.094-17.566-50.252-13.014-74.071 10.157-7.113 6.922-12.57 14.721-16.3 22.728-3.726-8.007-9.189-15.806-16.298-22.728-23.815-23.171-56.979-27.723-74.072-10.157-17.087 17.566-11.63 50.595 12.184 73.763 1.075 1.045 12.945 10.803 14.372 16.51 1.424 5.703 1.623 13.9-1.803 20.26h.514c-.075.043-.149.07-.225.114 19.709 9.72 41.89 15.19 65.347 15.19 23.438-.032 45.304-5.821 65.03-15.543"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeWidth: 3.174,
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-526.238 353.247c18.968-8.851 39.943-13.764 62.255-13.764 21.432 0 42.003 5.263 60.354 12.738M-394.512 316.5c-19.755-6.703-43.963-10.654-70.12-10.654-26.385 0-50.784 4.025-70.636 10.836"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.95,
  strokeLinejoin: "bevel",
  d: "M-486.315 180.212h42.504l-42.504 38.1h42.504z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-406.876 339.75c-18.191-6.387-37.545-11.02-57.62-11.02-20.462 0-40.173 4.762-58.66 11.374",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 3.174,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.997,
  d: "M-464.48 313.323l-9.974 5.003 9.973 4.97 9.973-4.97zM-506.166 318.263l-9.03 6.544 10.634 3.303 9.03-6.513zM-422.795 318.263l9.06 6.544-10.664 3.303-9.03-6.513z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.95,
  strokeLinejoin: "bevel",
  d: "M-486.314 180.212h42.522v38.099h-42.522z"
}), /*#__PURE__*/React.createElement("ellipse", {
  ry: 13.241,
  rx: 17.927,
  cy: 235.646,
  cx: -464.701,
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.95
}));

function SvgBlackKing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default SvgBlackKing;